import { Button, colors, Dialog, DialogActions, DialogContent, DialogContentText, Slide, TextField, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { useState } from "react";
import ServiceProvider from "../../../configuration/ServiceProvider";
import useBrands from "../../../../explorer/hooks/useBrands";
import { StyledBoxDialogTitle, StyledDialogContentText, StyledDialogTitle } from "./DialogCreateNewCart.style";
import AppIconsCartNew from "../../AppIcons/AppIconsCartNew";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import CommonDialog from "../../CommonDialog/CommonDialog";
import { useBasket } from "../../../hook/useBasket";
import { useApiError } from "../../../hook/useApiError";
import { useApiNotification } from "../../../hook/useApiNotification";
import { Basket } from "../../../../explorer/types";



export type BasketUploadCreateNewCartDialogProps = {
  open: boolean;
  onClose: any;
  onSave: any;
};

export const DialogCreateNewCart = (
    props: BasketUploadCreateNewCartDialogProps
) => {
    const handleClose = () => {
        props.onClose(false);
    };

    const [value, setValue] = useState("");
    const brand = useBrands().currentBrandUrl;
    const {t} = useTranslation();
    
    const basketOperation = useBasket();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = useApiError();
    const [notification, setNotification] = useApiNotification();

    const handleSave = async () => {
        //const result: any = await ServiceProvider.Basket.checkBasketName(brand,value);

        setLoading(true);

        const result = await basketOperation.createBasket(value);
        if (result && result.isError !== true) {
            const newBasket: Basket = result.result.find((x: { name: string; }) => x.name === value)!;
            props.onSave(newBasket.id);
            basketOperation.changeCurrentBasket(newBasket.id!);
        } else {
            setError(result.message);
        }
        
    };

    const [errorMessage, setErrorMessage] = useState<string | undefined>(
        undefined
    );

    return (
        <CommonDialog
            open={props.open}
            closeDialog={handleClose}
            dialogTitleLabel="basket.upload_new_basket_title"
            useDenyBtn={true}
            denyButtonText={"common.cancel"}
            confirmButtonText={"common.agree"}
            confirmButton={handleSave}
            children={
                <>
                    <StyledDialogContentText>
                        {t("common.spareparts.basket.type_new_basket_name")}
                    </StyledDialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        variant="standard"
                        id="name"
                        label={(
                            t("common.spareparts.basket.basket_name") as string
                        ).toUpperCase()}
                        placeholder={(
                            t("common.spareparts.basket.basket_name") as string
                        ).toUpperCase()}
                        type="text"
                        fullWidth
                        slotProps={{
                            input: {
                                color: "primary",
                            },
                            htmlInput: {
                                color: StyleguideSavioColors.grey,
                            },
                        }}
                        value={value}
                        onChange={(event: any) => {
                            setValue(event.target.value);
                            setErrorMessage("");
                        }}
                    />
                    <Typography variant="button" color="error">
                        {errorMessage}
                    </Typography>
                </>
            }
        ></CommonDialog>
    );
};


